module.exports = __webpack_public_path__ + "img/空白（纯页码居中）.be590db1.jpg";